// list
export const SETTINGS_GET = "SETTINGS_GET";
export const settingsSuccess = (settings) => ({
  type: SETTINGS_GET,
  payload: { settings },
});
